module.exports = __webpack_public_path__ + "static/media/header_icon_qr_shower.7ec0daec.svg";